import React, { useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { signInRequest } from '../../store/modules/auth/actions';

import Input from '../../components/Input';
import Button from '../../components/Button';
import Title from '../../components/Title';
import * as S from './styled';
import peixeLogin from "../../assets/peixe-solidario.svg";
import peixeLoginMobile from "../../assets/logo-mobile.svg";


const Login = () => {
  
  const dispatch = useDispatch();
  const loading = useSelector(state => state.auth.loading);
  
  const [cpf, setCpf] = useState("");
  const [pass, setPass] = useState("");
  const [borderCpf, setBorderCpf] = useState("#FDCB00");
  const [borderPass, setBorderPass] = useState("#FDCB00");
  
  function validationInput(e, inputType) {


    if (inputType === 'cpf') {

      const inputLength = e.replace(/_/g, '').length;

      if (inputLength >= 3 && inputLength < 14) {
        setBorderCpf('#CE1717');
      } else {
        setBorderCpf('#1FA528');
      }
    }

    if ( inputType === 'password' ) {

      const inputLength = e.length;

      if (inputLength >= 1 && inputLength < 6) {
        setBorderPass('#CE1717');
      } else {
        setBorderPass('#1FA528');
      }
    }
  }

  function handleSubmit(e) {
    e.preventDefault();
      
      dispatch(signInRequest( cpf, pass ));
      
      setCpf("");
      setPass("");
      setBorderCpf('#FDCB00');
      setBorderPass('#FDCB00');

  }
    
  return (
    <S.Container>
      <S.Logo src={ peixeLogin } alt="Peixe Solidário"/>
      <S.LogoMobile src={ peixeLoginMobile } alt="Peixe Solidário"/>
      <S.FormWrapper>
        <S.Form  onSubmit={ handleSubmit }>
          <Title text="Entrar" />
          <Input 
            type="text" 
            placeholder="000.000.000-00"
            mask="999.999.999-99" 
            label="Cpf"
            value={ cpf }
            method={ e => {
              setCpf(e.target.value);
              validationInput(e.target.value, 'cpf');
            }}
            border={ borderCpf }
          />
          <Input 
            type="password" 
            placeholder="••••••••"
            label="Senha"
            value={ pass }
            method={ e => {
              setPass(e.target.value);
              validationInput(e.target.value, 'password');
            }}
            border={ borderPass }
          />
          <Button type="submit" text={ loading ? 'Carregando...' : 'Acessar' } background="#0B4683"/>
        </S.Form>
      </S.FormWrapper>
    </S.Container>
  );
}

export default Login;